"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cvc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.8718 12.5842C13.17 12.4414 13.4217 12.2173 13.5982 11.9378C13.7746 11.6582 13.8686 11.3346 13.8693 11.004C13.8693 10.0335 13.0728 9.24675 12.0918 9.24675C11.1093 9.24675 10.3121 10.0335 10.3121 11.004C10.3129 11.3346 10.4071 11.6583 10.5839 11.9378C10.7606 12.2172 11.0127 12.4411 11.3111 12.5835V14.754H12.8718V12.5842ZM12.0918 17.625C8.95235 17.625 6.39935 15.102 6.39935 12C6.39935 8.898 8.95235 6.375 12.0918 6.375C14.6531 6.375 16.8244 8.055 17.5368 10.359H19.4988C18.7413 7.0065 15.7129 4.5 12.0911 4.5C7.89935 4.5 4.5011 7.85775 4.5011 12C4.5011 16.1423 7.89935 19.5 12.0911 19.5C15.7129 19.5 18.7413 16.9935 19.4988 13.641H17.5361C16.8236 15.945 14.6524 17.625 12.0911 17.625", fill: color }));
}
exports["default"] = cvc;
//# sourceMappingURL=cvc.js.map